import { openBlock as e, createElementBlock as t, createElementVNode as l } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, a = /* @__PURE__ */ l("path", {
  "fill-rule": "evenodd",
  d: "M11.605 3.077a1.386 1.386 0 0 0-1.96 0L4.143 8.579a2.454 2.454 0 1 0 3.47 3.47l5.503-5.502a.75.75 0 0 1 1.06 1.06L8.674 13.11a3.954 3.954 0 1 1-5.592-5.592l5.502-5.502a2.886 2.886 0 1 1 4.082 4.081l-5.287 5.287a1.818 1.818 0 0 1-2.57-2.571l4.638-4.64a.75.75 0 1 1 1.061 1.061l-4.64 4.64a.318.318 0 0 0 .45.45l5.287-5.287a1.386 1.386 0 0 0 0-1.96Z",
  "clip-rule": "evenodd"
}, null, -1), n = [
  a
];
function c(r, d) {
  return e(), t("svg", o, [...n]);
}
const i = { render: c };
export {
  i as default,
  c as render
};
